const actionTypes = {
    FETCH_PRODUCTS: 'FETCH_PRODUCTS',
    FETCH_CATEGORIES: 'FETCH_CATEGORIES',
    FETCH_PRODUCT_CONFIG: 'FETCH_PRODUCT_CONFIG',
    FETCH_PRODUCT_BY_CODE: 'FETCH_PRODUCT_BY_CODE',
    FETCH_PRODUCT_CODE_CONFIG: 'FETCH_PRODUCT_CODE_CONFIG',
    SAVE_PRODUCT_CODE_CONFIG: 'SAVE_PRODUCT_CODE_CONFIG',
    DELETE_FILE_PRODUCT_CODE_CONFIG: 'DELETE_FILE_PRODUCT_CODE_CONFIG',
    ADD_VARIANT: 'ADD_VARIANT',
};

export { actionTypes };
